// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"FH-z","smallCardRow":"GH-z","largeCardRow":"HH-z","productSearchRow":"IH-z","curatedRow":"JH-z"};